export default __webpack_public_path__ + "static/media/step_D@2x.01ec044b.png";